import React from 'react';
import { ResponsiveFunnel } from '@nivo/funnel';
import { Box, Grid, Typography } from '@mui/material';

import { useSettings } from 'app/main/components';
import { DetailsSectionWrapper } from 'app/main/components/page-layouts';

export default function DemsDetailsSectionStats({ model }: { model: any }) {
	const { t } = useSettings();

	const funnelData = [
		{
			id: 'step_sent',
			label: t('DEMS_STATISTICS_SENT'),
			value: model.dems_sent / model.dems_total
		},
		{
			id: 'step_delivered',
			label: t('DEMS_STATISTICS_DELIVERED'),
			value: (model.dems_sent - model.dems_bounced) / model.dems_total
		},
		{
			id: 'step_opened',
			label: t('DEMS_STATISTICS_OPENED'),
			value: model.dems_opened / model.dems_total
		},
		{
			id: 'step_clicked',
			label: t('DEMS_STATISTICS_CLICKED'),
			value: model.dems_clicked / model.dems_total
		}
	];

	return (
		<DetailsSectionWrapper title={t('DEMS_STATISTICS_SECTION')}>
			<Grid container direction="column" spacing={2}>
				<Grid size={12}>
					<Grid container justifyContent="space-between" spacing={1}>
						<Grid>
							<Grid container direction="column" justifyContent="space-evenly" spacing={1}>
								<Grid size={12}>
									<Typography>{t('DEMS_STATISTICS_TOTAL')}</Typography>
								</Grid>
								<Grid size={12}>
									<Typography>{t('DEMS_STATISTICS_SENT')}</Typography>
								</Grid>
								<Grid size={12}>
									<Typography>{t('DEMS_STATISTICS_DELIVERED')}</Typography>
								</Grid>
								<Grid size={12}>
									<Typography>{t('DEMS_STATISTICS_OPENED')}</Typography>
								</Grid>
								<Grid size={12}>
									<Typography>{t('DEMS_STATISTICS_CLICKED')}</Typography>
								</Grid>
								<Grid size={12}>
									<Typography>{t('DEMS_STATISTICS_UNSUBSCRIBED')}</Typography>
								</Grid>
							</Grid>
						</Grid>
						<Grid>
							<Grid container direction="column" justifyContent="space-evenly" spacing={1}>
								<Grid size={12}>
									<Typography align="right">{model.dems_total}</Typography>
								</Grid>
								<Grid size={12}>
									<Typography align="right">{model.dems_sent}</Typography>
								</Grid>
								<Grid size={12}>
									<Typography align="right">{model.dems_sent - model.dems_bounced}</Typography>
								</Grid>
								<Grid size={12}>
									<Typography align="right">{model.dems_opened}</Typography>
								</Grid>
								<Grid size={12}>
									<Typography align="right">{model.dems_clicked}</Typography>
								</Grid>
								<Grid size={12}>
									<Typography align="right">{model.dems_unsubscribed}</Typography>
								</Grid>
							</Grid>
						</Grid>
						<Grid>
							<Grid container direction="column" justifyContent="space-evenly" spacing={1}>
								<Grid size={12}>
									<Typography align="right">-</Typography>
								</Grid>
								<Grid size={12}>
									<Typography align="right">
										{`${((model.dems_sent * 100) / model.dems_total).toFixed(2)}%`}
									</Typography>
								</Grid>
								<Grid size={12}>
									<Typography align="right">
										{`${(((model.dems_sent - model.dems_bounced) * 100) / model.dems_total).toFixed(
											2
										)}%`}
									</Typography>
								</Grid>
								<Grid size={12}>
									<Typography align="right">
										{`${((model.dems_opened * 100) / model.dems_total).toFixed(2)}%`}
									</Typography>
								</Grid>
								<Grid size={12}>
									<Typography align="right">
										{`${((model.dems_clicked * 100) / model.dems_total).toFixed(2)}%`}
									</Typography>
								</Grid>
								<Grid size={12}>
									<Typography align="right">
										{`${((model.dems_unsubscribed * 100) / model.dems_total).toFixed(2)}%`}
									</Typography>
								</Grid>
							</Grid>
						</Grid>
					</Grid>
				</Grid>
				<Grid size={12}>
					<Box sx={{ height: 300, minHeight: 300 }}>
						<ResponsiveFunnel
							data={funnelData}
							// direction="horizontal"
							// interpolation="linear"
							valueFormat=">-.2%"
							colors={{ scheme: 'set1' }}
							borderWidth={16}
							labelColor={{ theme: 'labels.text.fill' }}
							beforeSeparatorLength={8}
							beforeSeparatorOffset={16}
							afterSeparatorLength={8}
							afterSeparatorOffset={16}
							currentPartSizeExtension={8}
							currentBorderWidth={16}
							motionConfig="stiff"
						/>
					</Box>
				</Grid>
			</Grid>
		</DetailsSectionWrapper>
	);
}
